import { render, staticRenderFns } from "./AddVehicleForm.vue?vue&type=template&id=286cc697"
import script from "./AddVehicleForm.vue?vue&type=script&lang=js"
export * from "./AddVehicleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports